import React, { useState } from 'react';
import { User, Briefcase, Shield, Bell, Settings, Camera, Upload, Trash2, MapPin, Save, Plus, ChevronDown, ChevronRight, Zap, BarChart2, TrendingUp, Users, Award, Layout, Calendar, MessageSquare, Coffee, HelpCircle, ArrowRight } from 'lucide-react';
export function ProfileSettingsPage() {
  const [activeSection, setActiveSection] = useState('overview');
  const [expandedSkillSection, setExpandedSkillSection] = useState(null);
  const [showDeletePhotoConfirm, setShowDeletePhotoConfirm] = useState(false);
  // Dati utente simulati
  const [userData, setUserData] = useState({
    name: 'Sophia Rossi',
    role: 'UX/UI Designer',
    location: 'Roma',
    bio: 'Designer con 7+ anni di esperienza in design di prodotto, con particolare focus su esperienze digitali user-centered.',
    email: 'sophia.rossi@example.com',
    phone: '+39 123 456 7890',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/woFngADa1aU2Q5MqNXmffj/pexels-olly-774909.jpg',
    skills: {
      designSkills: [{
        name: 'UX/UI Design',
        level: 90,
        expertise: 'Esperto'
      }, {
        name: 'Wireframing',
        level: 95,
        expertise: 'Esperto'
      }, {
        name: 'Interaction Design',
        level: 85,
        expertise: 'Avanzato'
      }],
      researchStrategy: [{
        name: 'User Research',
        level: 80,
        expertise: 'Avanzato'
      }, {
        name: 'Prototyping',
        level: 90,
        expertise: 'Esperto'
      }, {
        name: 'Design Thinking',
        level: 75,
        expertise: 'Avanzato'
      }],
      toolsTechnologies: [{
        name: 'Figma',
        level: 95,
        expertise: 'Esperto'
      }, {
        name: 'Adobe XD',
        level: 80,
        expertise: 'Avanzato'
      }, {
        name: 'HTML/CSS',
        level: 60,
        expertise: 'Intermedio'
      }]
    },
    impact: 85,
    kpis: {
      matchingCount: 24,
      collaborationsCount: 7,
      eventsAttended: 12,
      connectionsCount: 38
    }
  });
  // Gestione input
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  // Gestione upload immagine
  const handleImageUpload = e => {
    // Simulazione upload
    const file = e.target.files[0];
    if (file) {
      // In un'app reale, qui si farebbe l'upload dell'immagine
      console.log('Immagine caricata:', file.name);
    }
  };
  // Gestione competenze
  const handleSkillChange = (category, index, field, value) => {
    const updatedSkills = {
      ...userData.skills
    };
    updatedSkills[category][index][field] = value;
    setUserData(prev => ({
      ...prev,
      skills: updatedSkills
    }));
  };
  // Aggiunta nuova competenza
  const addSkill = category => {
    const newSkill = {
      name: '',
      level: 50,
      expertise: 'Intermedio'
    };
    const updatedSkills = {
      ...userData.skills
    };
    updatedSkills[category] = [...updatedSkills[category], newSkill];
    setUserData(prev => ({
      ...prev,
      skills: updatedSkills
    }));
  };
  // Rimozione competenza
  const removeSkill = (category, index) => {
    const updatedSkills = {
      ...userData.skills
    };
    updatedSkills[category] = updatedSkills[category].filter((_, i) => i !== index);
    setUserData(prev => ({
      ...prev,
      skills: updatedSkills
    }));
  };
  // Salvataggio modifiche
  const saveChanges = () => {
    // Simulazione salvataggio
    console.log('Dati salvati:', userData);
    alert('Modifiche salvate con successo!');
  };
  return <div className="max-w-6xl mx-auto w-full" data-id="element-2321">
      <h1 className="text-2xl md:text-3xl font-light font-sharp-grotesk mb-6" data-id="element-2322">
        Impostazioni profilo
      </h1>
      {/* Tab navigation - updated to match ConnectionsPage style and made sticky */}
      <div className="sticky top-0 z-10 bg-white mb-4 pb-2" data-id="element-2323">
        <div className="w-full overflow-x-auto hide-scrollbar" data-id="element-2324">
          <div className="flex items-center space-x-2 flex-nowrap min-w-max" data-id="element-2325">
            <button onClick={() => setActiveSection('overview')} className={`px-4 py-2 text-sm font-medium rounded-full ${activeSection === 'overview' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2326">
              <div className="flex items-center" data-id="element-2327">
                <Layout className="w-5 h-5 mr-2" data-id="element-2328" />
                Overview
              </div>
            </button>
            <button onClick={() => setActiveSection('profile')} className={`px-4 py-2 text-sm font-medium rounded-full ${activeSection === 'profile' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2329">
              <div className="flex items-center" data-id="element-2330">
                <User className="w-5 h-5 mr-2" data-id="element-2331" />
                Profilo
              </div>
            </button>
            <button onClick={() => setActiveSection('skills')} className={`px-4 py-2 text-sm font-medium rounded-full ${activeSection === 'skills' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2332">
              <div className="flex items-center" data-id="element-2333">
                <Briefcase className="w-5 h-5 mr-2" data-id="element-2334" />
                Competenze
              </div>
            </button>
            <button onClick={() => setActiveSection('privacy')} className={`px-4 py-2 text-sm font-medium rounded-full ${activeSection === 'privacy' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2335">
              <div className="flex items-center" data-id="element-2336">
                <Shield className="w-5 h-5 mr-2" data-id="element-2337" />
                Privacy
              </div>
            </button>
            <button onClick={() => setActiveSection('notifications')} className={`px-4 py-2 text-sm font-medium rounded-full ${activeSection === 'notifications' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2338">
              <div className="flex items-center" data-id="element-2339">
                <Bell className="w-5 h-5 mr-2" data-id="element-2340" />
                Notifiche
              </div>
            </button>
            <button onClick={() => setActiveSection('account')} className={`px-4 py-2 text-sm font-medium rounded-full ${activeSection === 'account' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2341">
              <div className="flex items-center" data-id="element-2342">
                <Settings className="w-5 h-5 mr-2" data-id="element-2343" />
                Account
              </div>
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col" data-id="element-2344">
        {/* Main content */}
        <div className="flex-1" data-id="element-2345">
          {/* Overview section */}
          {activeSection === 'overview' && <div data-id="element-2346">
              {/* KPI Cards */}
              <div className="mb-8" data-id="element-2347">
                <h3 className="text-lg font-medium mb-4" data-id="element-2348">KPI di rendimento</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-2349">
                  <div className="bg-white rounded-lg p-4 shadow-sm hover:shadow transition-shadow" data-id="element-2350">
                    <div className="flex items-center space-x-3 mb-3" data-id="element-2351">
                      <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-2352">
                        <Users className="w-5 h-5 text-black" data-id="element-2353" />
                      </div>
                      <span className="text-sm font-medium text-gray-700" data-id="element-2354">
                        Connections
                      </span>
                    </div>
                    <p className="text-2xl font-semibold text-gray-900 mb-1" data-id="element-2355">
                      {userData.kpis.connectionsCount}
                    </p>
                    <div className="flex items-center text-emerald-600 text-xs font-medium" data-id="element-2356">
                      <TrendingUp className="w-3 h-3 mr-1" data-id="element-2357" />
                      <span data-id="element-2358">+12% in the last month</span>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm hover:shadow transition-shadow" data-id="element-2359">
                    <div className="flex items-center space-x-3 mb-3" data-id="element-2360">
                      <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-2361">
                        <Calendar className="w-5 h-5 text-black" data-id="element-2362" />
                      </div>
                      <span className="text-sm font-medium text-gray-700" data-id="element-2363">
                        Events
                      </span>
                    </div>
                    <p className="text-2xl font-semibold text-gray-900 mb-1" data-id="element-2364">
                      {userData.kpis.eventsAttended}
                    </p>
                    <div className="flex items-center text-emerald-600 text-xs font-medium" data-id="element-2365">
                      <TrendingUp className="w-3 h-3 mr-1" data-id="element-2366" />
                      <span data-id="element-2367">+3 in the last month</span>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm hover:shadow transition-shadow" data-id="element-2368">
                    <div className="flex items-center space-x-3 mb-3" data-id="element-2369">
                      <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-2370">
                        <MessageSquare className="w-5 h-5 text-black" data-id="element-2371" />
                      </div>
                      <span className="text-sm font-medium text-gray-700" data-id="element-2372">
                        Matching
                      </span>
                    </div>
                    <p className="text-2xl font-semibold text-gray-900 mb-1" data-id="element-2373">
                      {userData.kpis.matchingCount}
                    </p>
                    <div className="flex items-center text-emerald-600 text-xs font-medium" data-id="element-2374">
                      <TrendingUp className="w-3 h-3 mr-1" data-id="element-2375" />
                      <span data-id="element-2376">+5 in the last month</span>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm hover:shadow transition-shadow" data-id="element-2377">
                    <div className="flex items-center space-x-3 mb-3" data-id="element-2378">
                      <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-2379">
                        <Coffee className="w-5 h-5 text-black" data-id="element-2380" />
                      </div>
                      <span className="text-sm font-medium text-gray-700" data-id="element-2381">
                        Collaborations
                      </span>
                    </div>
                    <p className="text-2xl font-semibold text-gray-900 mb-1" data-id="element-2382">
                      {userData.kpis.collaborationsCount}
                    </p>
                    <div className="flex items-center text-emerald-600 text-xs font-medium" data-id="element-2383">
                      <TrendingUp className="w-3 h-3 mr-1" data-id="element-2384" />
                      <span data-id="element-2385">+2 in the last month</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Impact Score */}
              <div className="mb-8 p-6 bg-white border border-gray-200 rounded-lg" data-id="element-2386">
                <h3 className="text-lg font-medium mb-4" data-id="element-2387">
                  Impatto nella community
                </h3>
                <div className="flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-2388">
                  <div className="w-32 h-32 flex flex-col items-center justify-center relative" data-id="element-2389">
                    <div className="relative w-full h-full flex items-center justify-center" data-id="element-2390">
                      <div className="flex flex-col items-center justify-center" data-id="element-2391">
                        <p className="text-3xl font-light font-sharp-grotesk text-black" data-id="element-2392">
                          {userData.impact}%
                        </p>
                        <p className="text-xs text-gray-500 mt-0.5 text-center" data-id="element-2393">
                          indice di impatto
                        </p>
                        <p className="text-base mt-1" data-id="element-2394">⭐⭐⭐</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-2395">
                    <h4 className="text-base font-medium mb-2" data-id="element-2396">
                      Impatto significativo
                    </h4>
                    <p className="text-sm text-gray-600 mb-4" data-id="element-2397">
                      Sei tra i membri più attivi della community. Il tuo
                      punteggio di impatto è calcolato in base alla tua
                      partecipazione agli eventi, collaborazioni e contributi
                      alla community.
                    </p>
                    <div className="space-y-3" data-id="element-2398">
                      <div data-id="element-2399">
                        <div className="flex justify-between items-center mb-1" data-id="element-2400">
                          <span className="text-sm" data-id="element-2401">Partecipazione eventi</span>
                          <span className="text-xs text-gray-500" data-id="element-2402">35%</span>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2403">
                          <div className="bg-black h-1.5 rounded-full" style={{
                        width: '35%'
                      }} data-id="element-2404"></div>
                        </div>
                      </div>
                      <div data-id="element-2405">
                        <div className="flex justify-between items-center mb-1" data-id="element-2406">
                          <span className="text-sm" data-id="element-2407">Collaborazioni</span>
                          <span className="text-xs text-gray-500" data-id="element-2408">28%</span>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2409">
                          <div className="bg-black h-1.5 rounded-full" style={{
                        width: '28%'
                      }} data-id="element-2410"></div>
                        </div>
                      </div>
                      <div data-id="element-2411">
                        <div className="flex justify-between items-center mb-1" data-id="element-2412">
                          <span className="text-sm" data-id="element-2413">Mentorship</span>
                          <span className="text-xs text-gray-500" data-id="element-2414">22%</span>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2415">
                          <div className="bg-black h-1.5 rounded-full" style={{
                        width: '22%'
                      }} data-id="element-2416"></div>
                        </div>
                      </div>
                      <div data-id="element-2417">
                        <div className="flex justify-between items-center mb-1" data-id="element-2418">
                          <span className="text-sm" data-id="element-2419">
                            Condivisione conoscenze
                          </span>
                          <span className="text-xs text-gray-500" data-id="element-2420">15%</span>
                        </div>
                        <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2421">
                          <div className="bg-black h-1.5 rounded-full" style={{
                        width: '15%'
                      }} data-id="element-2422"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* AI Suggestions */}
              <div className="mb-8" data-id="element-2423">
                <div className="flex justify-between items-center mb-4" data-id="element-2424">
                  <h3 className="text-lg font-medium" data-id="element-2425">Suggerimenti AI</h3>
                  <div className="flex items-center bg-gray-100 rounded-full px-3 py-1" data-id="element-2426">
                    <Zap className="w-4 h-4 text-yellow-500 mr-1" data-id="element-2427" />
                    <span className="text-xs font-medium" data-id="element-2428">Powered by AI</span>
                  </div>
                </div>
                <div className="space-y-4" data-id="element-2429">
                  <div className="bg-white rounded-lg overflow-hidden border border-gray-200" data-id="element-2430">
                    <div className="p-5 flex flex-col" data-id="element-2431">
                      <div className="flex mb-4 justify-start items-center" data-id="element-2432">
                        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200 z-2 relative" data-id="element-2433">
                          <img src="https://randomuser.me/api/portraits/men/85.jpg" alt="Esperto Blockchain" className="w-full h-full object-cover" data-id="element-2434" />
                        </div>
                        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200 z-1 relative -ml-6" data-id="element-2435">
                          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bPxviaDF98Buy2nnayRr63/vinicius-amnx-amano-0NCjjD0zGnw-unsplash_%281%29.jpg" alt="Esperto Blockchain" className="w-full h-full object-cover" data-id="element-2436" />
                        </div>
                        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200 z-0 relative -ml-6" data-id="element-2437">
                          <img src="https://randomuser.me/api/portraits/men/92.jpg" alt="Esperto Blockchain" className="w-full h-full object-cover" data-id="element-2438" />
                        </div>
                      </div>
                      <div className="flex-1" data-id="element-2439">
                        <div className="mb-1" data-id="element-2440">
                          <h3 className="font-medium font-sharp-grotesk" data-id="element-2441">
                            Opportunità di networking
                          </h3>
                        </div>
                        <p className="text-sm text-gray-600 mb-4" data-id="element-2442">
                          Oggi nell'Hub ci sono 3 persone che si occupano di
                          Blockchain. Vuoi organizzare un Topic Lunch con loro?
                        </p>
                        <div className="flex flex-col space-y-2" data-id="element-2443">
                          <button className="text-sm font-medium text-white bg-black px-4 py-1.5 rounded-lg hover:bg-gray-800 transition-colors flex items-center gap-1 w-fit" data-id="element-2444">
                            <Calendar className="w-4 h-4" data-id="element-2445" /> Organizza
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg overflow-hidden border border-gray-200" data-id="element-2446">
                    <div className="p-5 flex flex-col" data-id="element-2447">
                      <div className="flex justify-start items-center mb-4" data-id="element-2448">
                        <div className="relative w-12 h-12 flex-shrink-0" data-id="element-2449">
                          <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Marco B." className="w-12 h-12 rounded-full object-cover border-2 border-gray-200" data-id="element-2450" />
                          <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5 border border-gray-200 w-6 h-6 flex items-center justify-center" data-id="element-2451">
                            <span className="text-sm" role="img" aria-label="collaborazione" data-id="element-2452">
                              🤝
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex-1" data-id="element-2453">
                        <div className="mb-1" data-id="element-2454">
                          <h3 className="font-medium font-sharp-grotesk" data-id="element-2455">
                            Match di competenze
                          </h3>
                        </div>
                        <p className="text-sm text-gray-600 mb-4 font-normal" data-id="element-2456">
                          Le tue competenze in UX/UI design potrebbero essere
                          utili al progetto di Marco B. Vuoi conoscere di più?
                        </p>
                        <div className="flex flex-col space-y-2" data-id="element-2457">
                          <button className="text-sm font-medium text-white bg-black px-4 py-1.5 rounded-lg hover:bg-gray-800 transition-colors flex items-center gap-1 w-fit" data-id="element-2458">
                            <ArrowRight className="w-4 h-4" data-id="element-2459" /> Scopri
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Aumenta il tuo impatto section */}
              <div className="mb-8" data-id="element-2460">
                <div className="mb-4" data-id="element-2461">
                  <h3 className="text-lg font-medium mb-2" data-id="element-2462">
                    Aumenta il tuo impatto
                  </h3>
                  <div className="flex items-center bg-gray-100 rounded-full px-3 py-1 mt-2 w-fit" data-id="element-2463">
                    <span className="text-xs font-medium" data-id="element-2464">
                      Indice attuale: {userData.impact}%
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2465">
                  <div className="bg-white rounded-lg p-4 border border-gray-200 mb-4" data-id="element-2466">
                    <div className="flex gap-4" data-id="element-2467">
                      <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2468">
                        <Briefcase className="w-5 h-5 text-gray-700" data-id="element-2469" />
                      </div>
                      <div className="flex-1" data-id="element-2470">
                        <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-2471">
                          Collabora con Marco B.
                        </h3>
                        <p className="text-sm text-gray-600 mb-2" data-id="element-2472">
                          Il suo progetto Blockchain ha bisogno delle tue
                          competenze!
                        </p>
                        <div className="mb-3" data-id="element-2473">
                          <div className="flex justify-between items-center mb-1" data-id="element-2474">
                            <span className="text-xs text-gray-500" data-id="element-2475">
                              Impatto potenziale
                            </span>
                            <span className="text-xs font-medium" data-id="element-2476">+3%</span>
                          </div>
                          <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2477">
                            <div className="bg-black h-1.5 rounded-full" style={{
                          width: '3%'
                        }} data-id="element-2478"></div>
                          </div>
                        </div>
                        <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 w-fit" data-id="element-2479">
                          Contatta Marco
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-gray-200 mb-4" data-id="element-2480">
                    <div className="flex gap-4" data-id="element-2481">
                      <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2482">
                        <Award className="w-5 h-5 text-gray-700" data-id="element-2483" />
                      </div>
                      <div className="flex-1" data-id="element-2484">
                        <h3 className="font-medium font-sharp-grotesk mb-1" data-id="element-2485">
                          Partecipa al Pitch Day
                        </h3>
                        <p className="text-sm text-gray-600 mb-2" data-id="element-2486">
                          Condividi il tuo progetto con la community!
                        </p>
                        <div className="mb-3" data-id="element-2487">
                          <div className="flex justify-between items-center mb-1" data-id="element-2488">
                            <span className="text-xs text-gray-500" data-id="element-2489">
                              Impatto potenziale
                            </span>
                            <span className="text-xs font-medium" data-id="element-2490">+5%</span>
                          </div>
                          <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2491">
                            <div className="bg-black h-1.5 rounded-full" style={{
                          width: '5%'
                        }} data-id="element-2492"></div>
                          </div>
                        </div>
                        <button className="text-sm font-medium text-black bg-gray-100 px-4 py-1.5 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1 w-fit" data-id="element-2493">
                          Iscriviti ora
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {/* Profile section */}
          {activeSection === 'profile' && <div data-id="element-2494">
              {/* Profile photo section */}
              <div className="mb-8 p-6 bg-white border border-gray-200 rounded-lg" data-id="element-2495">
                <h3 className="text-lg font-medium mb-4" data-id="element-2496">Foto profilo</h3>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-2497">
                  <div className="relative" data-id="element-2498">
                    {userData.profileImage ? <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-gray-200" data-id="element-2499">
                        <img src={userData.profileImage} alt="Profile" className="w-full h-full object-cover" data-id="element-2500" />
                      </div> : <div className="w-32 h-32 rounded-full bg-gray-200 flex items-center justify-center border-2 border-gray-300" data-id="element-2501">
                        <User className="w-16 h-16 text-gray-400" data-id="element-2502" />
                      </div>}
                    <div className="absolute -bottom-2 -right-2 bg-white rounded-full p-1.5 shadow-md" data-id="element-2503">
                      <label className="cursor-pointer" data-id="element-2504">
                        <Camera className="w-5 h-5 text-gray-600" data-id="element-2505" />
                        <input type="file" className="hidden" accept="image/*" onChange={handleImageUpload} data-id="element-2506" />
                      </label>
                    </div>
                  </div>
                  <div className="space-y-4" data-id="element-2507">
                    <div data-id="element-2508">
                      <p className="text-sm text-gray-600 mb-2" data-id="element-2509">
                        Carica una foto chiara del tuo volto per aiutare altri
                        membri a riconoscerti.
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-2510">
                        Formati supportati: JPG, PNG. Dimensione massima: 5MB
                      </p>
                    </div>
                    <div className="flex gap-3" data-id="element-2511">
                      <label className="inline-flex items-center px-4 py-2 bg-black text-white rounded-lg text-sm font-medium cursor-pointer hover:bg-gray-800 transition-colors" data-id="element-2512">
                        <Upload className="w-4 h-4 mr-2" data-id="element-2513" />
                        Carica foto
                        <input type="file" className="hidden" accept="image/*" onChange={handleImageUpload} data-id="element-2514" />
                      </label>
                      {userData.profileImage && <button onClick={() => setShowDeletePhotoConfirm(true)} className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2515">
                          <Trash2 className="w-4 h-4 mr-2" data-id="element-2516" />
                          Rimuovi
                        </button>}
                    </div>
                  </div>
                </div>
              </div>
              {/* Personal information section */}
              <div className="mb-8 p-6 bg-white border border-gray-200 rounded-lg" data-id="element-2517">
                <h3 className="text-lg font-medium mb-4" data-id="element-2518">
                  Informazioni personali
                </h3>
                <div className="space-y-4" data-id="element-2519">
                  <div data-id="element-2520">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2521">
                      Nome completo
                    </label>
                    <input type="text" id="name" name="name" value={userData.name} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2522" />
                  </div>
                  <div data-id="element-2523">
                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2524">
                      Ruolo professionale
                    </label>
                    <input type="text" id="role" name="role" value={userData.role} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2525" />
                  </div>
                  <div data-id="element-2526">
                    <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2527">
                      Località
                    </label>
                    <div className="relative" data-id="element-2528">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2529">
                        <MapPin className="h-5 w-5 text-gray-400" data-id="element-2530" />
                      </div>
                      <input type="text" id="location" name="location" value={userData.location} onChange={handleInputChange} className="w-full pl-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2531" />
                    </div>
                  </div>
                  <div data-id="element-2532">
                    <label htmlFor="bio" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2533">
                      Biografia
                    </label>
                    <textarea id="bio" name="bio" rows={4} value={userData.bio} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" placeholder="Scrivi una breve descrizione di te e della tua esperienza professionale..." data-id="element-2534"></textarea>
                  </div>
                </div>
              </div>
              {/* Contact information section */}
              <div className="mb-8 p-6 bg-white border border-gray-200 rounded-lg" data-id="element-2535">
                <h3 className="text-lg font-medium mb-4" data-id="element-2536">
                  Informazioni di contatto
                </h3>
                <div className="space-y-4" data-id="element-2537">
                  <div data-id="element-2538">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2539">
                      Email
                    </label>
                    <input type="email" id="email" name="email" value={userData.email} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2540" />
                  </div>
                  <div data-id="element-2541">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2542">
                      Telefono
                    </label>
                    <input type="tel" id="phone" name="phone" value={userData.phone} onChange={handleInputChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2543" />
                  </div>
                </div>
              </div>
              {/* Save button */}
              <div className="flex justify-end" data-id="element-2544">
                <button onClick={saveChanges} className="inline-flex items-center px-6 py-3 bg-black text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors" data-id="element-2545">
                  <Save className="w-4 h-4 mr-2" data-id="element-2546" />
                  Salva modifiche
                </button>
              </div>
            </div>}
          {/* Skills section - Redesigned to avoid nesting widgets */}
          {activeSection === 'skills' && <div data-id="element-2547">
              <div className="mb-8 p-6 bg-white border border-gray-200 rounded-lg" data-id="element-2548">
                <p className="text-sm text-gray-600 mb-6" data-id="element-2549">
                  Gestisci le tue competenze per mostrare le tue capacità
                  professionali. Le competenze sono organizzate in categorie per
                  una migliore visualizzazione nel tuo profilo pubblico.
                </p>
                {/* Design Skills Header */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200 cursor-pointer" onClick={() => setExpandedSkillSection(expandedSkillSection === 'designSkills' ? null : 'designSkills')} data-id="element-2550">
                  <h3 className="text-base font-medium" data-id="element-2551">Design Skills</h3>
                  <button className="text-gray-500" data-id="element-2552">
                    {expandedSkillSection === 'designSkills' ? <ChevronDown className="w-5 h-5" data-id="element-2553" /> : <ChevronRight className="w-5 h-5" data-id="element-2554" />}
                  </button>
                </div>
                {/* Design Skills Content */}
                {expandedSkillSection === 'designSkills' && <div className="py-4 space-y-4" data-id="element-2555">
                    {userData.skills.designSkills.map((skill, index) => <div key={index} className="py-3" data-id="element-2556">
                        <div className="flex flex-wrap gap-4 items-end" data-id="element-2557">
                          <div className="flex-1 min-w-[200px]" data-id="element-2558">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2559">
                              Nome competenza
                            </label>
                            <input type="text" value={skill.name} onChange={e => handleSkillChange('designSkills', index, 'name', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2560" />
                          </div>
                          <div className="w-32" data-id="element-2561">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2562">
                              Livello
                            </label>
                            <select value={skill.expertise} onChange={e => handleSkillChange('designSkills', index, 'expertise', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2563">
                              <option value="Base" data-id="element-2564">Base</option>
                              <option value="Intermedio" data-id="element-2565">Intermedio</option>
                              <option value="Avanzato" data-id="element-2566">Avanzato</option>
                              <option value="Esperto" data-id="element-2567">Esperto</option>
                            </select>
                          </div>
                          <div className="flex-1 min-w-[200px]" data-id="element-2568">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2569">
                              Percentuale ({skill.level}%)
                            </label>
                            <input type="range" min="0" max="100" value={skill.level} onChange={e => handleSkillChange('designSkills', index, 'level', parseInt(e.target.value))} className="w-full accent-black" data-id="element-2570" />
                          </div>
                          <button onClick={() => removeSkill('designSkills', index)} className="p-2 text-gray-500 hover:text-red-500" data-id="element-2571">
                            <Trash2 className="w-5 h-5" data-id="element-2572" />
                          </button>
                        </div>
                        {index < userData.skills.designSkills.length - 1 && <div className="mt-3 border-t border-gray-100" data-id="element-2573"></div>}
                      </div>)}
                    <button onClick={() => addSkill('designSkills')} className="mt-2 inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2574">
                      <Plus className="w-4 h-4 mr-2" data-id="element-2575" />
                      Aggiungi competenza
                    </button>
                  </div>}
                {/* Research & Strategy Header */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200 cursor-pointer mt-4" onClick={() => setExpandedSkillSection(expandedSkillSection === 'researchStrategy' ? null : 'researchStrategy')} data-id="element-2576">
                  <h3 className="text-base font-medium" data-id="element-2577">Research & Strategy</h3>
                  <button className="text-gray-500" data-id="element-2578">
                    {expandedSkillSection === 'researchStrategy' ? <ChevronDown className="w-5 h-5" data-id="element-2579" /> : <ChevronRight className="w-5 h-5" data-id="element-2580" />}
                  </button>
                </div>
                {/* Research & Strategy Content */}
                {expandedSkillSection === 'researchStrategy' && <div className="py-4 space-y-4" data-id="element-2581">
                    {userData.skills.researchStrategy.map((skill, index) => <div key={index} className="py-3" data-id="element-2582">
                        <div className="flex flex-wrap gap-4 items-end" data-id="element-2583">
                          <div className="flex-1 min-w-[200px]" data-id="element-2584">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2585">
                              Nome competenza
                            </label>
                            <input type="text" value={skill.name} onChange={e => handleSkillChange('researchStrategy', index, 'name', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2586" />
                          </div>
                          <div className="w-32" data-id="element-2587">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2588">
                              Livello
                            </label>
                            <select value={skill.expertise} onChange={e => handleSkillChange('researchStrategy', index, 'expertise', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2589">
                              <option value="Base" data-id="element-2590">Base</option>
                              <option value="Intermedio" data-id="element-2591">Intermedio</option>
                              <option value="Avanzato" data-id="element-2592">Avanzato</option>
                              <option value="Esperto" data-id="element-2593">Esperto</option>
                            </select>
                          </div>
                          <div className="flex-1 min-w-[200px]" data-id="element-2594">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2595">
                              Percentuale ({skill.level}%)
                            </label>
                            <input type="range" min="0" max="100" value={skill.level} onChange={e => handleSkillChange('researchStrategy', index, 'level', parseInt(e.target.value))} className="w-full accent-black" data-id="element-2596" />
                          </div>
                          <button onClick={() => removeSkill('researchStrategy', index)} className="p-2 text-gray-500 hover:text-red-500" data-id="element-2597">
                            <Trash2 className="w-5 h-5" data-id="element-2598" />
                          </button>
                        </div>
                        {index < userData.skills.researchStrategy.length - 1 && <div className="mt-3 border-t border-gray-100" data-id="element-2599"></div>}
                      </div>)}
                    <button onClick={() => addSkill('researchStrategy')} className="mt-2 inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2600">
                      <Plus className="w-4 h-4 mr-2" data-id="element-2601" />
                      Aggiungi competenza
                    </button>
                  </div>}
                {/* Tools & Technologies Header */}
                <div className="flex items-center justify-between py-3 border-b border-gray-200 cursor-pointer mt-4" onClick={() => setExpandedSkillSection(expandedSkillSection === 'toolsTechnologies' ? null : 'toolsTechnologies')} data-id="element-2602">
                  <h3 className="text-base font-medium" data-id="element-2603">
                    Tools & Technologies
                  </h3>
                  <button className="text-gray-500" data-id="element-2604">
                    {expandedSkillSection === 'toolsTechnologies' ? <ChevronDown className="w-5 h-5" data-id="element-2605" /> : <ChevronRight className="w-5 h-5" data-id="element-2606" />}
                  </button>
                </div>
                {/* Tools & Technologies Content */}
                {expandedSkillSection === 'toolsTechnologies' && <div className="py-4 space-y-4" data-id="element-2607">
                    {userData.skills.toolsTechnologies.map((skill, index) => <div key={index} className="py-3" data-id="element-2608">
                        <div className="flex flex-wrap gap-4 items-end" data-id="element-2609">
                          <div className="flex-1 min-w-[200px]" data-id="element-2610">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2611">
                              Nome competenza
                            </label>
                            <input type="text" value={skill.name} onChange={e => handleSkillChange('toolsTechnologies', index, 'name', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2612" />
                          </div>
                          <div className="w-32" data-id="element-2613">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2614">
                              Livello
                            </label>
                            <select value={skill.expertise} onChange={e => handleSkillChange('toolsTechnologies', index, 'expertise', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent" data-id="element-2615">
                              <option value="Base" data-id="element-2616">Base</option>
                              <option value="Intermedio" data-id="element-2617">Intermedio</option>
                              <option value="Avanzato" data-id="element-2618">Avanzato</option>
                              <option value="Esperto" data-id="element-2619">Esperto</option>
                            </select>
                          </div>
                          <div className="flex-1 min-w-[200px]" data-id="element-2620">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2621">
                              Percentuale ({skill.level}%)
                            </label>
                            <input type="range" min="0" max="100" value={skill.level} onChange={e => handleSkillChange('toolsTechnologies', index, 'level', parseInt(e.target.value))} className="w-full accent-black" data-id="element-2622" />
                          </div>
                          <button onClick={() => removeSkill('toolsTechnologies', index)} className="p-2 text-gray-500 hover:text-red-500" data-id="element-2623">
                            <Trash2 className="w-5 h-5" data-id="element-2624" />
                          </button>
                        </div>
                        {index < userData.skills.toolsTechnologies.length - 1 && <div className="mt-3 border-t border-gray-100" data-id="element-2625"></div>}
                      </div>)}
                    <button onClick={() => addSkill('toolsTechnologies')} className="mt-2 inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2626">
                      <Plus className="w-4 h-4 mr-2" data-id="element-2627" />
                      Aggiungi competenza
                    </button>
                  </div>}
              </div>
              {/* Save button */}
              <div className="flex justify-end" data-id="element-2628">
                <button onClick={saveChanges} className="inline-flex items-center px-6 py-3 bg-black text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors" data-id="element-2629">
                  <Save className="w-4 h-4 mr-2" data-id="element-2630" />
                  Salva modifiche
                </button>
              </div>
            </div>}
          {/* Placeholder for Privacy section */}
          {activeSection === 'privacy' && <div className="p-6 bg-white border border-gray-200 rounded-lg" data-id="element-2631">
              <h3 className="text-lg font-medium mb-4" data-id="element-2632">Impostazioni privacy</h3>
              <p className="text-gray-600" data-id="element-2633">
                Le impostazioni della privacy ti consentono di controllare chi
                può vedere il tuo profilo e le tue attività.
              </p>
            </div>}
          {/* Placeholder for Notifications section */}
          {activeSection === 'notifications' && <div className="p-6 bg-white border border-gray-200 rounded-lg" data-id="element-2634">
              <h3 className="text-lg font-medium mb-4" data-id="element-2635">
                Impostazioni notifiche
              </h3>
              <p className="text-gray-600" data-id="element-2636">
                Gestisci le notifiche che ricevi via email e all'interno della
                piattaforma.
              </p>
            </div>}
          {/* Placeholder for Account section */}
          {activeSection === 'account' && <div className="p-6 bg-white border border-gray-200 rounded-lg" data-id="element-2637">
              <h3 className="text-lg font-medium mb-4" data-id="element-2638">Impostazioni account</h3>
              <p className="text-gray-600" data-id="element-2639">
                Gestisci le impostazioni del tuo account, inclusi abbonamento,
                fatturazione e sicurezza.
              </p>
            </div>}
        </div>
      </div>
    </div>;
}